import { Campaign } from '../types';

// Normaliza a estrutura da campanha independente do tracking_level
export const normalizeCampaign = (campaign: any): Campaign => {
    if (campaign.tracking_level === 'adset') {
        return {
            ...campaign,
            campaign_id: campaign.campaign?.campaign_id || campaign.campaign_id,
            campaign_name: campaign.campaign?.campaign_name || campaign.campaign_name || campaign.adset_name,
            adsets: campaign.campaign?.adsets || [],
            domain: campaign.domain,
            isAdsetTracking: true,
            trackedAdsetId: campaign.adset_id,
        };
    }
    return {
        ...campaign,
        isAdsetTracking: false,
    };
};

// Formatadores
export const fmt = {
    currency: (v: number) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD' }).format(v),
    currencyBRL: (v: number) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v),
    number: (v: number) => new Intl.NumberFormat('pt-BR').format(v),
    percent: (v: number) => `${v.toFixed(2)}%`,
};

export interface TrackingInfo {
    hasTracking: boolean;
    trackingLevel: 'campaign' | 'adset' | 'ad' | null;
    customTracking: string | null;
}

/**
 * Verifica o tracking em qualquer nível (campaign, adset ou ad)
 * IMPORTANTE: Um item pode ter tracking mesmo que não seja do seu nível,
 * desde que herde de um nível superior
 */
export function getTrackingInfo(
    item: any
): TrackingInfo {
    const hasCustomTracking = item.has_custom_tracking;
    const customTrackingLevel = item.custom_tracking_level;
    const customTracking = item.custom_tracking;

    if (!hasCustomTracking || !customTracking) {
        return {
            hasTracking: false,
            trackingLevel: null,
            customTracking: null,
        };
    }

    // Item tem tracking - retorna as informações
    return {
        hasTracking: true,
        trackingLevel: customTrackingLevel,
        customTracking: customTracking,
    };
}

/**
 * Verifica se um item tem receita (independente do tracking)
 */
export function hasRevenue(item: any): boolean {
    return (item.revenue_impressions > 0 || item.revenue > 0);
}

/**
 * Determina qual badge de tracking mostrar baseado no nível de tracking
 */
export function getTrackingDisplay(item: any): {
    label: string;
    color: string;
    tracking: string | null;
} | null {
    if (!item.has_custom_tracking || !item.custom_tracking) return null;

    const level = item.custom_tracking_level;
    const tracking = item.custom_tracking;

    switch (level) {
        case 'campaign':
            return {
                label: 'Rastreado (Campanha)',
                color: 'bg-blue-600 text-white',
                tracking
            };
        case 'adset':
            return {
                label: 'Rastreado (AdSet)',
                color: 'bg-purple-600 text-white',
                tracking
            };
        case 'ad':
            return {
                label: 'Rastreado (Ad)',
                color: 'bg-indigo-600 text-white',
                tracking
            };
        default:
            return null;
    }
}

/**
 * Verifica se o tracking pode ser configurado neste nível
 * Regra: Só pode configurar tracking se não houver tracking em nenhum nível
 */
export function canConfigureTracking(item: any): boolean {
    return !item.has_custom_tracking;
}

/**
 * Verifica se o tracking pode ser removido neste nível
 * Regra: Só pode remover tracking do nível específico onde foi configurado
 */
export function canRemoveTracking(
    item: any,
    currentLevel: 'campaign' | 'adset' | 'ad'
): boolean {
    return item.has_custom_tracking && item.custom_tracking_level === currentLevel;
}